import { AlertTriangle } from 'lucide-react'
import clsx from 'clsx'

interface Props {
  title: string
  text: string
  confirmLabel: string
  danger?: boolean
  onConfirm: () => void
  onCancel: () => void
  isPending: boolean
}

export default function ConfirmModal({
  title, text, confirmLabel, danger = false, onConfirm, onCancel, isPending,
}: Props) {
  return (
    <>
      <div className="fixed inset-0 z-50 bg-black/40" onClick={onCancel} />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none">
        <div className="pointer-events-auto w-full max-w-sm rounded-xl bg-white shadow-2xl p-6">
          <div className="flex items-start gap-3 mb-4">
            <AlertTriangle className={clsx('h-5 w-5 flex-shrink-0 mt-0.5', danger ? 'text-rose-500' : 'text-amber-500')} />
            <div>
              <h3 className="font-semibold text-gray-900">{title}</h3>
              <p className="text-sm text-gray-600 mt-1">{text}</p>
            </div>
          </div>
          <div className="flex gap-2 justify-end">
            <button
              onClick={onCancel}
              className="rounded-lg border border-gray-200 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
            >
              Отмена
            </button>
            <button
              onClick={onConfirm}
              disabled={isPending}
              className={clsx(
                'rounded-lg px-4 py-2 text-sm font-medium text-white disabled:opacity-50 transition-colors',
                danger ? 'bg-rose-600 hover:bg-rose-700' : 'bg-amber-500 hover:bg-amber-600',
              )}
            >
              {isPending ? 'Подождите...' : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
